



































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { AddSupplierInfo } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import { VImageUpload } from '@/components/upload'
import constan from '@/utils/constant'

@Component({
  components: { VImageUpload },
})
export default class CreateSupplierDialog extends Vue {
  private show = false
  private data: any = {
    supplierStatus: 0,
    isShop: false,
    supplierDescImgList: [],
    sort:0,
  }
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    activityTheme: [this.requiredRule],
    activityStartTime: [this.requiredRule],
  }
  private supplierStatus = constan.SupplierStatus
  private supplierShopType = constan.SupplierShopType

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
    this.data = {
      supplierStatus: 0,
      isShop: true,
      supplierDescImgList: [],
      sort: 0,
    }
  }
  public open() {
    this.show = true
  }

  public async save() {
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      this.data.supplierDescImg = this.data.supplierDescImgList.map((e: any) => e.url).join(',')
      await AddSupplierInfo(this.data)
      Message.success('保存')
      this.close()
    })
  }
}
